import React from 'react';
import ReactDOM from 'react-dom'
import App from '../src/PortfolioComponents/Portfolio'

ReactDOM.render(
      <>
      
      <App/>
    </>
  ,
  document.getElementById('root')
)
